import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AcceptTermsAndConditionsPageRoutingModule } from './accept-terms-and-conditions-routing.module';

import { AcceptTermsAndConditionsPage } from './accept-terms-and-conditions.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AcceptTermsAndConditionsPageRoutingModule
  ],
  declarations: [AcceptTermsAndConditionsPage]
})
export class AcceptTermsAndConditionsPageModule {}
